const api = `/logistics-service/api/external`;

export const addressesContext = {
  countries: `${api}/countries`,
  provinces: `${api}/provinces`,
  districts: `${api}/districts`,
  communes: `${api}/communes`,
  villages: `${api}/villages`,
};
